import { render, staticRenderFns } from "./WoLFeedbackCard.vue?vue&type=template&id=3323d072&scoped=true&"
import script from "./WoLFeedbackCard.vue?vue&type=script&lang=js&"
export * from "./WoLFeedbackCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323d072",
  null
  
)

export default component.exports